import { Main } from "./CORE/Main";
/*
import "./style.css";
import "./FormStyle.css";
import "./Toast.css";
import "./list.css"
import "./styleMobile.css"
*/
import "./STYLES/styles.css"

const app = new Main();

const originalWarn = console.warn;
console.warn = (...args) => {
  if (args[0]?.includes?.("THREE.DataUtils.toHalfFloat")) {return;}
  originalWarn(...args);
};

app.start();